import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { toast } from "react-toastify";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import TextInput from "../../common/Form/textInput";
import CheckboxInput from "../../common/Form/CheckboxInput";
import Button from "apollo-react/components/Button";
import { FormikSelect, FormikSwitch, FormikTextField, FormikDatePicker } from '../../common/FormikComponent';
import Grid from "apollo-react/components/Grid";

import Accordion from 'apollo-react/components/Accordion';
import AccordionDetails from 'apollo-react/components/AccordionDetails';
import AccordionSummary from 'apollo-react/components/AccordionSummary';
import Typography from 'apollo-react/components/Typography';

import CheckboxChecked from 'apollo-react-icons/CheckboxChecked';
import CheckboxError from 'apollo-react-icons/CheckboxError';
import CheckboxIndeterminate from 'apollo-react-icons/CheckboxIndeterminate';

import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';

const PrivilegesForm = ({ persona, caseProp }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [privileges, setPrivileges] = useState([]);
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);
  const [boxesState, setBoxesState] = useState([]);
  const [published, setPublished] = useState(false);
  const [sections, setSections] = useState([{}]);
  const [isSectionSelected, setIsSectionSelected] = useState({});

  const { id } = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    axiosInstance
      .get("/api/privileges")
      .then((response) => {
        setPrivileges(response.data);
        setBoxesState(new Array(response.data.length).fill(false));

        let allPriviliges = response.data;
        let currentResource = allPriviliges[0].Resource.title;
        let currentSections = [{}];
        currentSections.pop();
        divideSectionsFromPriviliges(
          allPriviliges,
          currentResource,
          currentSections
        );
        console.log("current sections", currentSections);
        setSections(currentSections);
      })
      .catch((error) => {
        console.error("error fetching the privileges", error);
      });
  }, [axiosInstance, id]);

  const divideSectionsFromPriviliges = (allPriviliges, currentResource, currentSections) => {
  allPriviliges.forEach((priv) => {
    if (priv.Resource.title === currentResource) {
      if (!currentSections[currentResource]) {
        currentSections[currentResource] = [];
      }
      currentSections[currentResource].push(priv);
    } else {
      currentResource = priv.Resource.title;
      currentSections[currentResource] = [priv];
    }
  });
};

  useEffect(() => {
    if (id && caseProp === "role") {
      axiosInstance
        .get(`/api/roles/${id}`)
        .then((response) => {
          setName(response.data.name);
          setPublished(response.data.published);
          setDescription(response.data.description);
        })
        .catch((err) => {
          console.log(err);
        });

      axiosInstance
        .get(`/api/roles-privileges/${id}`)
        .then((response) => {
          let grantedPrivileges = response.data.map(
            (priv) => priv.Privilege.id
          );
          handleGrantedPriviligesWithCheckedBoxesAndSections(grantedPrivileges);
        })
        .catch((error) => {
          console.error("error fetching the privileges", error);
        });
    } else if (id && caseProp === "user") {
      axiosInstance
        .get(`/api/users-priviliges/${id}`)
        .then((resp) => {
          let grantedPrivileges = resp.data.map((priv) => priv.Privilege.id);
          handleGrantedPriviligesWithCheckedBoxesAndSections(grantedPrivileges);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, privileges, axiosInstance, sections, caseProp]);

  const handleGrantedPriviligesWithCheckedBoxesAndSections = (
    grantedPrivileges
  ) => {
    setBoxesState((boxes) => {
      return privileges.map((privilege) =>
        grantedPrivileges.includes(privilege.id)
      );
    });
    setSelectedPrivileges(grantedPrivileges);

    Object.entries(sections).forEach(([key, value]) => {
      setSectionInitialSelection(key);
    });
  };
  const setSectionInitialSelection = (resource) => {
    let c = 0;
    let privilege;
    selectedPrivileges.forEach((id) => {
      privilege = privileges.find((priv) => priv.id === id);
      if (privilege && privilege.Resource.title === resource) {
        c++;
      }
    });
    setIsSectionSelected((prev) => ({
      ...prev,
      [resource]: c === sections[resource].length,
    }));
  };

  const handleNameChange = (value) => {
    setName(value);
  };
  const handleDescriptionChange = (value) => {
    setDescription(value);
  };
  const handleCheckboxChange = (priv, index) => {
    let array = [];
    boxesState.forEach((box, idx) => {
      if (idx === index) {
        array.push(!box);
      } else {
        array.push(box);
      }
    });
    setBoxesState(array);

    let selected = [];
    array.forEach((element, idx) => {
      if (element) selected.push(privileges[idx].id);
    });
    let allSectionSelected = true;
    sections[priv.Resource.title].forEach((privilege) => {
      if (
        privilege.name === "read" &&
        !selected.includes(privilege.id) &&
        priv.name !== "read" &&
        array[index]
      ) {
        selected.push(privilege.id);
        setBoxesState((prev) => {
          let updatedBoxes = [...prev];
          updatedBoxes[
            privileges.findIndex((p) => p.id === privilege.id)
          ] = true;
          return updatedBoxes;
        });
      }
      if (!selected.includes(privilege.id)) {
        allSectionSelected = false;
      }
    });
    if (allSectionSelected)
      setIsSectionSelected((prev) => ({ ...prev, [priv.Resource.name]: true }));
    else
      setIsSectionSelected((prev) => ({
        ...prev,
        [priv.Resource.title]: false,
      }));
    setSelectedPrivileges(selected);
  };

  const handleSectionSelection = (resource) => {
    let currentSelected = [...selectedPrivileges];
    let sectionPriviliges = sections[resource];
    let isCurrentlySelected = isSectionSelected[resource];

    if (isCurrentlySelected) {
      // Unselect all privileges in the section
      sectionPriviliges.forEach((priv) => {
        currentSelected = currentSelected.filter((id) => id !== priv.id);
      });
    } else {
      // Select all privileges in the section
      sectionPriviliges.forEach((priv) => {
        if (!currentSelected.includes(priv.id)) {
          currentSelected.push(priv.id);
        }
      });
    }

    setSelectedPrivileges(currentSelected);

    let updatedBoxes = [...boxesState];
    privileges.forEach((priv, index) => {
      updatedBoxes[index] = currentSelected.includes(priv.id);
    });
    setBoxesState(updatedBoxes);

    setIsSectionSelected((prevState) => ({
      ...prevState,
      [resource]: !isCurrentlySelected,
    }));
  };
  const handleSelectAll = () => {
    if (selectedPrivileges.length === privileges.length) {
      setSelectedPrivileges([]);
      setBoxesState(new Array(privileges.length).fill(false));
      setIsSectionSelected(
        Object.keys(sections).reduce((acc, resource) => {
          acc[resource] = false;
          return acc;
        }, {})
      );
    } else {
      setSelectedPrivileges(privileges.map((priv) => priv.id));
      setBoxesState(new Array(privileges.length).fill(true));
      setIsSectionSelected(
        Object.keys(sections).reduce((acc, resource) => {
          acc[resource] = true;
          return acc;
        }, {})
      );
    }
  };

  const handleSubmit = async () => {

    if (caseProp === "role") {
      const formData = {
        name: name,
        description: description,
        privileges: selectedPrivileges,
        published: published,
      };

      if (!id) {
        await axiosInstance
          .post("/api/roles-privileges/role-privileges", formData)
          .then((resp) => {
            toast.success(t("Role Created Successfully"), {
              position: "top-center",
            });
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        await axiosInstance
          .put(`/api/roles-privileges/${id}`, formData)
          .then((resp) => {
            toast.success(t("Role Updated Successfully"), {
              position: "top-center",
            });
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else if (caseProp === "user") {
      await axiosInstance
        .put(`/api/users-priviliges`, {
          privileges: selectedPrivileges,
          userId: id,
        })
        .then((resp) => {
          toast.success(t("Privilegs Updated Successfully"), {
            position: "top-center",
          });
          navigate(-1);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
		<Grid container spacing={2}>
				<Grid item md={12}>
					<Formik
						initialValues={{ name, description, privileges, published: false }}
						enableReinitialize={true}
						onSubmit={handleSubmit}
					>
						<Form>
							{caseProp === "role" && (
								<>
                  <FormikTextField
                    fullWidth
                    name="name"
                    label="Role group name"
                    required
                    value={name || ""}
                    onChange={(e) => handleNameChange(e.target.value)}
                  />

                  <FormikTextField
                    fullWidth
                    name="description"
                    label="Description"
                    // required
                    multiline
                    value={description || ""}
                    onChange={(e) => handleDescriptionChange(e.target.value)}
                  />
								</>
							)}

              <Accordion defaultExpanded size="small" style={{ marginTop: '24px', backgroundColor: 'white' }}>
                <AccordionSummary>
                  <Typography>Systems</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ padding: '0px' }}>
                  <Grid container spacing={2}>
                    {sections &&
											Object.entries(sections || {}).map(([key, value]) => {
                        return (
                          <Grid item xs={12} md={4} key={key} style={{ padding: '0 0 0 20px', marginTop: '9px' }}>
                            <Card tabIndex={0} interactive style={{ width: '100%', height: '100%', borderRadius: '5px', padding: '0px', margin: '7px 0px', backgroundColor: 'white', overflow: 'hidden' }}>
                              <CardHeader
                                style={{
                                  width: '100%',
                                  padding: '11px 7px 0px 7px',
                                  fontSize: '16px',
                                  fontWeight: '600',
                                  color: '#000000',
                                }}
                                avatar={
                                  (() => {
                                    const selected = isSectionSelected[key];
                                    console.log("selected", selected);
                                    console.log("key", key);

                                    if (selected) {
                                      // All checkboxes selected
                                      return (
                                        <>
                                          <CheckboxChecked style={{ color: 'rgb(7, 104, 253)' }} />
                                          <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>{capitalizeFirstLetter(key)}</span>
                                        </>
                                      );
                                    }
                                    //  else if (selected === 0) {
                                    //   // None selected
                                    //   return (
                                    //     <>
                                    //       <CheckboxError style={{ color: 'rgb(7, 104, 253)' }} />
                                    //       <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>{capitalizeFirstLetter(key)}</span>
                                    //     </>
                                    //   );
                                    // }
                                     else {
                                      // Some selected
                                      return (
                                        <>
                                          <CheckboxIndeterminate style={{ color: 'rgb(7, 104, 253)' }} />
                                          <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>{capitalizeFirstLetter(key)}</span>
                                        </>
                                      );
                                    }
                                  })()
                                }
                              />

                              <CardContent style={{ width: '100%', paddingTop: '24px' }}>
                                  <Field name="select_all">
                                    {({ field, meta }) => (
                                      <CheckboxInput
                                        {...field}
                                        meta={meta}
                                        label={"Select All"}
                                        checked={isSectionSelected[key]}
                                        value={published}
                                        onChange={(checked) => {
                                          console.log(checked);

                                          // event.stopPropagation();
                                          handleSectionSelection(key);
                                        }}
                                        style={{ padding: 0 }}
                                      />
                                    )}
                                  </Field>

                                  {Array.isArray(value) &&
                                  value.map((priv) => {
                                    const globalIndex = privileges.findIndex(
                                      (p) => p.id === priv.id
                                    );
                                      return (
                                        <div
                                          className="form-check mt-2"
                                          key={priv.id}
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                        >
                                          <Field name={priv.id}>
                                            {({ field, meta }) => (
                                              <CheckboxInput
                                                {...field}
                                                meta={meta}
                                                label={capitalizeFirstLetter(
                                                  priv?.name === "read" ? "read only" : priv?.name
                                                )}
                                                value={parseInt(priv.id)}
                                                checked={boxesState[globalIndex]}
                                                onChange={() => {
                                                  handleCheckboxChange(
                                                    priv,
                                                    globalIndex
                                                  );
                                                }}
                                                style={{ padding: 0, fontWeight: '400' }}
                                              />
                                            )}
                                          </Field>
                                        </div>
                                      );
                                  })}
                              </CardContent>

                            </Card>
                          </Grid>
                        );
											})}
                    </Grid>
                </AccordionDetails>
              </Accordion>
              
              {caseProp === "role" && (
                <>
                <Field name="published">
                  {({ field, meta }) => (
                    <CheckboxInput
                      {...field}
                      meta={meta}
                      label={"Published"}
                      value={published}
                      checked={published}
                      style={{fontWeight: '400', marginTop: '50px'}}
                      onChange={(checked) => {
                        console.log("checked", checked);
                        setPublished(checked);
                      }}
                    />
                  )}
                </Field>
                </>
              )}
              
              <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '50px'}}>
              <Button
									variant="primary"
									onClick={handleSelectAll}
									style={{
										backgroundColor: "#ffc107",
										padding: "12px 22px",
										width: "157px",
										height: "40px",
                    marginRight: '24px',
									}}
								>
									{selectedPrivileges.length === privileges.length
										? "Unselect All"
										: "Select All"}
								</Button>
								<Button
									variant="primary"
									type="submit"
									style={{
										padding: "12px 22px",
										width: "157px",
										height: "40px",
									}}
								>
									Save
								</Button>
							</div>
						</Form>
					</Formik>
				</Grid>
		</Grid>
	);
};

export default PrivilegesForm;
